"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Button_1 = require("./Button");
const cards_scss_1 = __importDefault(require("./styles/cards.scss"));
const collaborator_icons_scss_1 = __importDefault(require("./styles/collaborator-icons.scss"));
const flex_scss_1 = __importDefault(require("./styles/flex.scss"));
const Transition_1 = require("./Transition");
function CollaboratorIcons({}) {
    const collaborators = react_redux_1.useSelector((state) => state.user.collaborators);
    const [selected, setSelected] = React.useState('1');
    const wrapperRef = React.useRef(null);
    const [shrink, setShrink] = React.useState(false);
    const needSpace = (collaborators.length - 1) * (36 - 8) + (160 - 8) + 8;
    React.useEffect(() => {
        const resize = () => {
            if (!wrapperRef.current)
                return;
            setShrink(needSpace > wrapperRef.current.offsetWidth);
        };
        resize();
        window.addEventListener('resize', resize, { passive: true });
        return () => {
            window.removeEventListener('resize', resize);
        };
    }, [needSpace]);
    const [open, setOpen] = React.useState(false);
    return (React.createElement("div", { ref: wrapperRef, className: classnames_1.default(collaborator_icons_scss_1.default.wrapper, flex_scss_1.default.horizontal) }, shrink ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: collaborator_icons_scss_1.default.shrink, onClick: () => setOpen(!open) }, open ? React.createElement(Button_1.Icon, { name: "arrow_drop_up" }) : collaborators.length),
        React.createElement(Transition_1.Transition, { in: open, className: classnames_1.default(collaborator_icons_scss_1.default.popout, flex_scss_1.default.vertical, cards_scss_1.default.elevated), exiting: collaborator_icons_scss_1.default.exiting }, collaborators.map(user => (React.createElement(Item, { key: user.id, open: true, user: user })))))) : (collaborators.map(user => (React.createElement(Item, { key: user.id, user: user, open: user.id === selected, onSelect: setSelected }))))));
}
exports.CollaboratorIcons = CollaboratorIcons;
function Item({ user, open, onSelect }) {
    return (React.createElement("div", { className: classnames_1.default(collaborator_icons_scss_1.default.item, open && collaborator_icons_scss_1.default.open, !user.asset && collaborator_icons_scss_1.default.nothing), style: { backgroundColor: user.color }, onClick: () => onSelect && onSelect(user.id) },
        open ? (React.createElement("div", { className: collaborator_icons_scss_1.default.asset }, user.asset ? React.createElement("img", { src: user.asset.iconUrl, alt: "" }) : null)) : null,
        open ? (React.createElement("div", { className: collaborator_icons_scss_1.default.text },
            React.createElement("div", { className: collaborator_icons_scss_1.default.userName }, user.name),
            React.createElement("div", { className: collaborator_icons_scss_1.default.assetName }, user.asset ? user.asset.name.ja : 'Nothing'))) : null,
        React.createElement("img", { src: user.iconUrl, alt: "" })));
}
